import React from 'react';
import { Route, Switch } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useWorkspace } from '@mssgme/hooks';
import { SidebarHeader, ScrollableBox, NavBackButton } from '@mssgme/ui';

import EmailSignature from './EmailSignature';
import ShareQR from './ShareQR';
import MoreVisits from './MoreVisits';
import WidgetEdit from '../WidgetEdit';
import { PageLayout } from '../../../UI';

import styles from './PageShare.scss';

// eslint-disable-next-line react/prop-types
function Layout({ children }) {
    const [header, ...rest] = React.Children.toArray(children);

    return (
        <>
            {header}
            <ScrollableBox>
                <div className={styles.content}>{rest}</div>
            </ScrollableBox>
        </>
    );
}

// TODO: refactor
export default function PageShare() {
    const { t } = useTranslation('cards');
    const { card } = useWorkspace();

    return (
        <PageLayout>
            <Switch>
                <Route
                    path="/p/share/sign"
                    exact
                    render={() => (
                        <Layout>
                            <SidebarHeader
                                heading={t('pageShare.emailSign')}
                                leftButton={<NavBackButton to="/p/share" />}
                            />
                            <EmailSignature
                                url={card.profile.absoluteUrl}
                                photo={card.design.photoUrl}
                                username={card.profile.fullname}
                            />
                        </Layout>
                    )}
                />
                <Route
                    path="/p/share/qr"
                    exact
                    render={() => (
                        <Layout>
                            <SidebarHeader
                                heading={t('pageShare.share_qr')}
                                leftButton={<NavBackButton to="/p/share" />}
                            />
                            <ShareQR url={card.profile.qrUrl} />
                        </Layout>
                    )}
                />
                <Route path="/p/share/widget" exact component={WidgetEdit} />
                <Route
                    path="/p/share"
                    exact
                    render={() => (
                        <Layout>
                            <SidebarHeader heading={t('pageShare.heading')} leftButton={<NavBackButton to="/p" />} />
                            <MoreVisits url={card.profile.absoluteUrl} />
                        </Layout>
                    )}
                />
            </Switch>
        </PageLayout>
    );
}
